import React, {useState, useCallback, Suspense} from 'react'
import { useTranslation } from "react-i18next"
import { useSelector } from 'react-redux'

import { ReactComponent as OPERATION_ICON } from '../../assets/control_panel/panel/operation.svg'
import { ReactComponent as BUILDING_TYPE_ICON } from '../../assets/control_panel/panel/building.svg'
import { ReactComponent as POST_ICON } from '../../assets/control_panel/panel/post.svg'
import { ReactComponent as APPLICATION_ICON } from '../../assets/control_panel/panel/application.svg'
import { ReactComponent as SETTING_ICON } from '../../assets/control_panel/panel/setting.svg'
import { ReactComponent as SUPPORT_ICON } from '../../assets/control_panel/panel/support.svg'


const ControlPanel = ({mode}) => {
    const { t } = useTranslation()

    const BasePanel = React.lazy(() => import('./panels/BasePanel'));
    const OperationPanel = React.lazy(() => import('./panels/OperationPanel'));
    const BuildingTypePanel = React.lazy(() => import('./panels/BuildingTypePanel'));
    const PostPanel = React.lazy(() => import('./panels/PostPanel'));
    const ApplicationSystemPanel = React.lazy(() => import('./panels/ApplicationSystemPanel'));
    const SettingPanel = React.lazy(() => import('./panels/SettingPanel'));
    const SupportPanel = React.lazy(() => import('./panels/SupportPanel'));
    
    const tabs = [
        { alias: 'operation', name: t("control-panel.menu.operation"), text_key: "control-panel.menu.operation", icon: <OPERATION_ICON/>, content: <OperationPanel/> },
        { alias: 'building', name: t("control-panel.menu.building_type"), text_key: "control-panel.menu.building_type", icon : <BUILDING_TYPE_ICON/>, content: <BuildingTypePanel/> },
        { alias: 'post', name: t("control-panel.menu.post"), text_key: "control-panel.menu.post", icon: <POST_ICON/>, content: <PostPanel/>  },
        { alias: 'application_system', name: t("control-panel.menu.application"), text_key: "control-panel.menu.application", icon: <APPLICATION_ICON/>, content: <ApplicationSystemPanel/> },
        { alias: 'setting', name: t("control-panel.menu.setting"), text_key: "control-panel.menu.setting", icon: <SETTING_ICON/>, content: <SettingPanel/> },
        { alias: 'support',name: t("control-panel.menu.support"), text_key: "control-panel.menu.support", icon: <SUPPORT_ICON/>, content: <SupportPanel/> }
    ]

    const {isLoading} = useSelector(state => ({
        isLoading: state.regions.status === "loading"
    }))

    const [value, setValue] = useState(tabs[0].alias)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderTabs = useCallback(() => {
        return tabs.map((tab, index)=> {
                    const active = value === tab.alias ? "active": ""
                    tab.name = t(tab.text_key)
                    return (
                        <button 
                            key={index} 
                            className={`tab nav-link ${active}`} 
                            id={`tabpanel-${tab.alias}-tab`} 
                            data-bs-toggle="pill" 
                            data-bs-target={`#tabpanel-${tab.alias}`}
                            type="button" 
                            role="tab" 
                            aria-controls={`tabpanel-${tab.alias}`}
                            aria-selected="true" 
                            onClick={(event) => handleChange(event, tab.alias)}
                        >
                            <div className="icon">{tab.icon}</div>
                            <div className="text">{tab.name}</div>
                        </button>
                    )
                })
    },[value, t])

    const renderTabContents = useCallback(() => {
        return tabs.map((tab, index)=> {
            const show = value === tab.alias ? "show": ""
            const hidden = value !== tab.alias ? 'hidden' : ""
            return (
                <div 
                    key={`tabpanel-${tab.alias}`}
                    className={`tab-panel fade ${show}`}
                    id={`tabpanel-${tab.alias}`}
                    role="tabpanel" 
                    aria-labelledby={`tabpanel-${tab.alias}-tab`}
                    hidden={hidden}
                >
                    {tab.content}
                </div> 
            )
        })
    },[value])

    const renderControlPanel = useCallback(() => {
        return (
            <>
                <div className="tabs nav flex-column" role="tablist" aria-orientation="vertical">
                    {renderTabs()}
                </div>
                <BasePanel mode={mode}>
                    {renderTabContents()}
                </BasePanel>
            </>
        )
    }, [mode, value])

    return (
        <div className={`control-panel`}>
            {renderControlPanel()}
        </div>
    )

}

ControlPanel.defaultProps = {
    mode: "daily",
}

export default ControlPanel